import {useEffect, useRef, useState} from "react"
import {Card} from "react-bootstrap";

import Entities from "./entities";
import SearchBox from "./search";
import Footer from "./footer";
import Tools from "./tools";
import Preloader from "../preloader";

const ListingTable = (props) => {

    const {
        entities, columns, totalEntities, currentPage, filters, searchColumn, searchColumns,
        actions, currentOrder, edit, template, addons, currentLimit, isLoading,
        onChangePage, onChangeLimit, onChangeOrder, onChangeAction, onClickApply,
        onSearch, onChooseSearchColumn, onCleanSearch, isModal, onInsert, card,
        progress, rowActions, idColumn
    } = props;


    const [searchActive, setSearchActive] = useState(false);
    const [allChecked, setAllChecked] = useState(false);
    const [checked, setChecked] = useState([]);
    const searchRef = useRef();


    useEffect(() => {
    }, [entities])



    const handleCheck = (event) => {
        var updatedList = [...checked];
        if (event.target.checked) {
            updatedList = [...checked, event.target.value];
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1);
        }
        setChecked(updatedList);
    };


    const selectAll = (event) => {
        const selected = [];
        setAllChecked(event.target.checked);
        entities.map((entity) => {
            if (event.target.checked) {
                selected.push(idColumn ? entity[idColumn] : entity?._id?.$oid);
            }
        });
        setChecked(selected);
    };


    const handleCloseSearch = () => {
        searchRef.current.value = ''
        setSearchActive(false)
        onCleanSearch()
    }


    const TableContent = <>
        <Preloader maskOnly isReady={!isLoading}/>
        {addons?.afterCard && <span>{addons?.afterCard}</span>}

        <div className="position-relative">
            {searchActive && <SearchBox
                onSearch={onSearch}
                searchRef={searchRef}
                searchColumn={searchColumn}
                searchColumns={searchColumns}
                handleCloseSearch={handleCloseSearch}
                onChooseSearchColumn={onChooseSearchColumn}
            />}

            <Tools
                addons={addons}
                actions={actions}
                checked={checked}
                filters={filters}
                onClickApply={onClickApply}
                searchActive={searchActive}
                onChangeLimit={onChangeLimit}
                onChangeOrder={onChangeOrder}
                onChangeAction={onChangeAction}
                setSearchActive={setSearchActive}
            />
        </div>

        <Entities
            idColumn={idColumn}
            columns={columns}
            checked={checked}
            entities={entities}
            selectAll={selectAll}
            isLoading={isLoading}
            handleCheck={handleCheck}
            progress={progress}
            rowActions={rowActions}
        />

        <Footer
            addons={addons}
            currentPage={currentPage}
            onChangePage={onChangePage}
            currentLimit={currentLimit}
            totalEntities={totalEntities}
        />
    </>


    return (
        <>
            {card !== false && <Card>{TableContent}</Card>}
            {card === false && TableContent}
        </>
    )
}

export default ListingTable